import { ReactNode } from 'react';
import { Trans } from '@lingui/react/macro';
import LoginLayout from './layouts/LoginLayout';
import Loader from './Loader';

interface AuthLoadingScreenProps {
  message?: ReactNode;
}

function AuthLoadingScreen({ message }: AuthLoadingScreenProps) {
  return (
    <LoginLayout noCard>
      <Loader>{message ?? <Trans>Verifying your session…</Trans>}</Loader>
    </LoginLayout>
  );
}

export default AuthLoadingScreen;
